export function convertRemToPixels(rem) {
    return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
}

export function convertValueToPixels(value) {
    if (typeof value === "number") {
        return value;
    }
    if (typeof value !== "string") {
        return parseInt(value);
    }
    value = value.toLowerCase();
    if (value.indexOf('px') > -1) {
        return parseInt(value.replace('px',''));
    }
    if (value.indexOf('rem') > -1) {
        return this.convertRemToPixels(parseInt(value.replace('rem','')));
    }
    if (value.indexOf('em') > -1) {
        return this.convertRemToPixels(parseInt(value.replace('em','')));
    }
    return parseInt(value);
}